import { SITE_CONFIG_BY_SITE_NAME, SiteName } from "@benkrejci/shared/src/config";

export const config = SITE_CONFIG_BY_SITE_NAME[process.env.REACT_APP_SITE_NAME as SiteName]

export const isDev = process.env.NODE_ENV === 'development'
